/**
 * Shared list pagination — matches AllWebsites / AllWebsiteGroups.
 */
export const LIST_PAGE_SIZE_DEFAULT = 25;

export const LIST_PAGE_SIZE_OPTIONS: number[] = [10, 25, 50, 100];

export const LIST_FOOTER_PROPS = {
  'items-per-page-options': LIST_PAGE_SIZE_OPTIONS,
  showFirstLastPage: true,
};

export type ListPaginationOptions = {
  page: number;
  itemsPerPage: number;
};

export function defaultListOptions(): ListPaginationOptions {
  return {
    page: 1,
    itemsPerPage: LIST_PAGE_SIZE_DEFAULT,
  };
}

export function parseListQuery(
  query: { [key: string]: string | (string | null)[] | null | undefined },
): ListPaginationOptions {
  const page = Number(query.page);
  const pageSize = Number(query.pageSize);
  return {
    page: page > 0 ? page : 1,
    itemsPerPage: pageSize > 0 ? pageSize : LIST_PAGE_SIZE_DEFAULT,
  };
}

export function buildListPaginationQuery(
  options: ListPaginationOptions,
  extra?: { [key: string]: string },
): { [key: string]: string } {
  const query: { [key: string]: string } = extra ? { ...extra } : {};
  if (options.page > 1) {
    query.page = String(options.page);
  }
  if (options.itemsPerPage > 0 && options.itemsPerPage !== LIST_PAGE_SIZE_DEFAULT) {
    query.pageSize = String(options.itemsPerPage);
  }
  return query;
}

export function listPaginationQueryEquals(
  routeQuery: { [key: string]: string | (string | null)[] | null | undefined },
  options: ListPaginationOptions,
  extraKeys: string[] = [],
  extra?: { [key: string]: string },
): boolean {
  const next = buildListPaginationQuery(options, extra);
  const keys = ['page', 'pageSize'].concat(extraKeys);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const left = typeof routeQuery[key] === 'string' ? routeQuery[key] : '';
    const right = next[key] || '';
    if (left !== right) {
      return false;
    }
  }
  return true;
}

export function effectivePageSize(itemsPerPage: number): number {
  return itemsPerPage > 0 ? itemsPerPage : LIST_PAGE_SIZE_DEFAULT;
}
